import { Config } from "@pages/configs/config";
import { apiSend, getRoute } from "@services/axios";
import { Eye, Plus } from "lucide-react";
import { LinkButton } from "rc-easyui";
import { useEffect, useMemo, useState } from "react";
import { Button, Col, FloatingLabel, Form, Modal, Pagination, Row, Spinner, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt, FaChevronLeft, FaChevronRight, FaInfoCircle } from "react-icons/fa";
import { TbBookmarkPlus } from "react-icons/tb";
import FormSearch from "./FormSearch";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const List = () => {
    const { t } = useTranslation();
    const config = new Config(t);
    const [loading, setLoading] = useState(false);
    const [ticketList, setTicketList] = useState([]);
    const [total, setTotal] = useState(0);
    const [show, setShow] = useState(false);
    const [status, setStatus] = useState(null);
    const [priority, setPriority] = useState(null);
    const [ticketServiceOptions, setTicketServiceOption] = useState([]);

    const initialFormData = useMemo(() => ({
        subject: "",
        selectedService: "",
        selectedPriority: "low",
        message: ""
    }), []);

    const [formData, setFormData] = useState(initialFormData);
    // Load ticket services on mount
    useEffect(() => {
        const loadTicketServices = async () => {
            try {
                const response = await apiSend(getRoute("ticket_service"), "get");
                if (response?.data?.result) {
                    const services = response.data.result || [];
                    setTicketServiceOption(services);
                    // Set default selected service when options are loaded
                    if (services.length > 0) {
                        setFormData(prev => ({
                            ...prev,
                            selectedService: String(services[0].id)
                        }));
                    }
                }
            } catch (error) {
                console.error("Failed to load ticket services:", error);
                setTicketServiceOption([]);
            }
        };

        loadTicketServices();
    }, [])

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(20); // or your preferred page size
    const [maxVisiblePages, setMaxVisiblePages] = useState(5);


    console.log("servicees", ticketServiceOptions)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 576) {
                setMaxVisiblePages(2); // mobile
            } else if (window.innerWidth < 768) {
                setMaxVisiblePages(3); // tablet
            } else {
                setMaxVisiblePages(5); // desktop
            }
        };

        handleResize(); // run on mount
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getStatusClass = (status) => {
        const statusMap = {
            'new': 'status-confirmed',
            'in_progress': 'status-pending',
            'waiting': 'status-cancelled',
            'resolved': 'status-completed',
            'closed': 'status-cancelled',
        };
        return statusMap[status?.toLowerCase()] || 'status-pending';
    };



    const totalPages = Math.ceil(total / pageSize);
    console.log('ticket', Math.ceil(total / pageSize))
    const loadData = async (page) => {
        setLoading(true);
        setCurrentPage(page);

        const payload = {
            status: status ? status.value : "",
            priority: priority ? priority.value : "",
        };

        const response = await apiSend(
            getRoute("ticket_list") + "?page=" + page,
            "post",
            payload
        );

        if (response?.data?.result) {


            console.log("ticketlist", response.data.result)
            setTicketList(response.data.result.data || []);
            setTotal(response.data.result.total || 0);
        }
        setLoading(false);
    };

    useEffect(() => {
        const timerId = setTimeout(async () => {
            await loadData(1);
        }, 100);
        return () => {
            clearTimeout(timerId);
        };
    }, [status, priority]);

    const handlePageChange = (page) => {
        loadData(page);
    };

    const handleClose = () => {
        setShow(false);
        // Reset form on close
        setFormData({
            subject: "",
            selectedService: "1",
            selectedPriority: "low",
            message: ""
        });
    };

    const handleShow = () => {

        setShow(true)
    }

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleServiceChange = (e) => {
        setFormData(prev => ({
            ...prev,
            selectedService: e.target.value
        }));
    };

    const handlePriorityChange = (e) => {
        setFormData(prev => ({
            ...prev,
            selectedPriority: e.target.value
        }));
    };

    const handleSubmit = async () => {
        const payload = {
            subject: formData.subject,
            support_service_id: parseInt(formData.selectedService, 10),
            priority: formData.selectedPriority,
            message: formData.message
        };

        const response = await apiSend(
            getRoute("ticket_new"),
            "post",
            payload
        );

        if (response?.data?.result) {
            toast.success(t('new ticket created'));
            console.log('payload', payload);
            console.log('new ticket created', response?.data?.result);
            handleClose();
            // Refresh the list
            loadData(1);
        }
        if (response?.data?.result?.Error) {
            console.log(response?.data?.result?.Error.message)
            toast.error(response?.data?.result?.Error.message[0]);
        }
    };

    return (
        <>
            <div className="py-4 ">
                <div className="my-2 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                    <Button
                        onClick={handleShow}
                        className="btn-custom"
                    >
                        <TbBookmarkPlus size={25} /> {t("new_ticket")}
                    </Button>


                    <FormSearch
                        status={status}
                        priority={priority}
                        setPriority={setPriority}
                        setStatus={setStatus}
                        loadData={loadData}
                    />
                </div>

                {loading ? (
                    <div className="d-flex justify-content-center py-5">
                        <Spinner animation="border" variant="primary" className="text-blue" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive-custom">
                            <Table className="table booking-table mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th className="text-start">{t("id")}</th>
                                        <th className="text-start">{t("subject")}</th>
                                        <th className="text-center d-none d-md-table-cell">{t("service")}</th>
                                        <th className="text-center d-none d-sm-table-cell">{t("status")}</th>
                                        <th className="text-center d-none d-md-table-cell">{t("priority")}</th>
                                        <th className="text-center d-none d-lg-table-cell">{t("created_at")}</th>
                                        <th className="text-center d-none d-xl-table-cell">{t("created_by")}</th>
                                        <th className="text-center">{t("action")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ticketList.map((row, index) => (
                                        <tr key={row.id || index} className="booking-row">
                                            <td>
                                                <div className="booking-number">
                                                    <span className="fw-semibold text-dark">{row.id}</span>
                                                </div>
                                            </td>
                                            <td className="fw-medium text-dark">{row.subject}</td>
                                            <td className="fw-medium text-dark text-center d-none d-md-table-cell">{row.service}</td>
                                            <td className="text-center d-none d-sm-table-cell">
                                                <span className={`status-badge ${getStatusClass(row.status)}`}>
                                                    {row.status}
                                                </span>
                                            </td>
                                            <td className="fw-medium text-dark text-center d-none d-md-table-cell">{row.priority}</td>
                                            <td className="text-center d-none d-lg-table-cell">
                                                <span className="text-secondary d-inline-flex align-items-center gap-2">
                                                    <FaCalendarAlt className="text-blue" size={14} />
                                                    {row.created_at}
                                                </span>
                                            </td>
                                            <td className="fw-medium text-dark text-center d-none d-xl-table-cell">{row.createBy}</td>
                                            <td className="text-center">
                                                <button type="button" className="view-btn">
                                                    <a target="_blank" href={`/tickets/${row.id}`} rel="noopener noreferrer">
                                                        <Eye size={18} strokeWidth={1.5} />
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>

                        {totalPages > 1 && (
                            <Row className="justify-content-between align-items-center mt-4 px-2">
                                <Col xs={12}
                                    lg={5} xl={6} className="text-secondary d-inline-flex align-items-center gap-2">
                                    <FaInfoCircle className="text-blue" size={14} />
                                    {t("showing")} {ticketList.length} {t("of")} {total} {t("products")}
                                </Col>
                                <Col xs={12}
                                    lg={7} xl={6} className="d-flex gap-2 justify-content-end mt-2">
                                    <Pagination className="custom-pagination mb-0">
                                        <Pagination.First
                                            onClick={() => handlePageChange(1)}
                                            disabled={currentPage === 1}
                                            className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                        >
                                            <FaChevronLeft size={12} />
                                            <FaChevronLeft size={12} className="ms-1" style={{ marginLeft: '-4px' }} />
                                        </Pagination.First>
                                        <Pagination.Prev
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                        >
                                            <FaChevronLeft size={12} />
                                        </Pagination.Prev>

                                        {Array.from(
                                            { length: Math.min(maxVisiblePages, totalPages) },
                                            (_, i) => {
                                                let pageNum;

                                                const half = Math.floor(maxVisiblePages / 2);

                                                if (totalPages <= maxVisiblePages) {
                                                    // Total pages less than visible limit
                                                    pageNum = i + 1;
                                                } else if (currentPage <= half + 1) {
                                                    // Near the beginning
                                                    pageNum = i + 1;
                                                } else if (currentPage >= totalPages - half) {
                                                    // Near the end
                                                    pageNum = totalPages - maxVisiblePages + i + 1;
                                                } else {
                                                    // Middle range
                                                    pageNum = currentPage - half + i;
                                                }

                                                return (
                                                    <Pagination.Item
                                                        key={pageNum}
                                                        active={pageNum === currentPage}
                                                        onClick={() => handlePageChange(pageNum)}
                                                        className="border-0 rounded-3"
                                                    >
                                                        {pageNum}
                                                    </Pagination.Item>
                                                );
                                            }
                                        )}
                                        <Pagination.Next
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                        >
                                            <FaChevronRight size={12} />
                                        </Pagination.Next>
                                        <Pagination.Last
                                            onClick={() => handlePageChange(totalPages)}
                                            disabled={currentPage === totalPages}
                                            className="border-0 rounded-3 d-flex align-items-center justify-content-center"
                                        >
                                            <FaChevronRight size={12} />
                                            <FaChevronRight size={12} className="ms-1" style={{ marginLeft: '-4px' }} />
                                        </Pagination.Last>
                                    </Pagination>
                                </Col>
                            </Row>
                        )}
                    </>
                )}
            </div>

            <style jsx="true">{`
                .table-container {
                    box-shadow: 0 20px 40px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                }

                .booking-table {
                    border-collapse: separate;
                    border-spacing: 0;
                    width: 100%;
                    font-size: 0.95rem;
                }

                .booking-table thead th {
                    position: sticky;
                    top: 0;
                    background: #f8fafd;
                    border-bottom: 2px solid #e2e8f0;
                    padding: 18px 16px !important;
                    font-weight: 600;
                    color: #1e293b;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    z-index: 10;
                    white-space: nowrap;
                }

                .booking-table tbody tr {
                    transition: all 0.2s ease;
                    border-bottom: 1px solid #f1f5f9;
                }

                .booking-table tbody tr:hover {
                    background-color: var(--secondary-blue) !important;
                    cursor: pointer;
                }

                .booking-table td {
                    padding: 16px !important;
                    vertical-align: middle;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                    background: white;
                    white-space: nowrap;
                }

                .booking-number {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    font-weight: 500;
                    color: #0f172a;
                }

                .status-badge {
                    padding: 6px 16px;
                    border-radius: 30px;
                    font-size: 0.85rem;
                    font-weight: 600;
                    display: inline-block;
                    text-transform: capitalize;
                    letter-spacing: 0.3px;
                    transition: all 0.2s ease;
                }

                .status-confirmed {
                    background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
                    color: #2563eb;
                    border: 1px solid #bfdbfe;
                }

                .status-pending {
                    background: linear-gradient(135deg, #fef3c7 0%, #fffbeb 100%);
                    color: #d97706;
                    border: 1px solid #fde68a;
                }

                .status-cancelled {
                    background: linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%);
                    color: #dc2626;
                    border: 1px solid #fecaca;
                }

                .status-completed {
                    background: linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%);
                    color: #16a34a;
                    border: 1px solid #bbf7d0;
                }

                .view-btn {
                    background: transparent;
                    border: none;
                    padding: 10px;
                    cursor: pointer;
                    border-radius: 10px;
                    transition: all 0.2s ease;
                    color: #64748b;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                }

                .view-btn:hover {
                    background: var(--secondary-blue);
                    color: var(--primary-blue);
                    transform: scale(1.1);
                }

                .table-responsive-custom {
                    width: 100%;
                    overflow-x: auto;
                    -webkit-overflow-scrolling: touch;
                }

                .custom-pagination .page-item .page-link {
                    border: none;
                    margin: 0 4px;
                    border-radius: 10px !important;
                    color: var(--primary-blue);
                    font-weight: 500;
                    padding: 8px 14px;
                    transition: all 0.2s ease;
                    box-shadow: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 40px;
                    height: 40px;
                }

                .custom-pagination .page-item.active .page-link {
                    background: var(--primary-blue);
                    color: white;
                    border-color: var(--primary-blue);
                }

                .custom-pagination .page-item .page-link:hover {
                    background: var(--secondary-blue);
                    color: var(--primary-blue);
                    transform: translateY(-2px);
                }

                .bg-blue {
                    background: var(--primary-blue) !important;
                    transition: all 0.2s ease;
                }

                .bg-blue:hover {
                    opacity: 0.9;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 16px rgba(149, 73, 248, 0.25) !important;
                }

                .text-blue {
                    color: var(--primary-blue) !important;
                }
            `}</style>
            <ToastContainer position="top-center" />
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton className="bg-blue text-white">
                    <Modal.Title>{t("new_ticket")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-black">
                        <Form.Label htmlFor="subject">{t("subject")}</Form.Label>
                        <Form.Control
                            type="text"
                            id="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            maxLength={100}
                            aria-describedby="subjectHelpBlock"
                        />
                        <Form.Text id="subjectHelpBlock" muted>
                            {t("subject_help_block")}
                        </Form.Text>
                    </div>
                    <Row className="mt-3">
                        <Col>

                            <Form.Select
                                aria-label="ticketService"
                                value={formData.selectedService}
                                onChange={handleServiceChange}
                            >
                                {ticketServiceOptions.map(({ id, name }) => (
                                    <option key={id} value={String(id)}>
                                        {name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Select
                                aria-label="ticketPriority"
                                value={formData.selectedPriority}
                                onChange={handlePriorityChange}
                            >
                                {config.ticketPriorityOptions().map(({ value, label }) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="mt-3 px-3 text-dark">
                        <Form.Label htmlFor="message">{t("message")}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            id="message"
                            value={formData.message}
                            onChange={handleInputChange}
                            maxLength={350}
                            aria-describedby="messageHelpBlock"
                        />
                        <Form.Text id="messageHelpBlock" muted>
                            {formData.message.length}/{350} {t("characters")}
                            {formData.message.length >= 350 && (
                                <span className="text-danger ms-2">
                                    {t("maximum_characters_reached")}
                                </span>
                            )}
                        </Form.Text>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("close")}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={!formData.subject || !formData.message}
                    >
                        {t("submit")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default List;